module.exports = __webpack_public_path__ + "img/IMG_0459_L_Black.4dd62ad4.jpg";